import React from 'react';

const Vue_Server = () => {
  return (
    <div>
      <h1>Vue_Server Component</h1>
      <p>This is the Vue_Server tutorial page.</p>
    </div>
  );
}

export default Vue_Server;
